// @ts-nocheck
import axios from 'axios';
import { create } from 'zustand';
import { API_URL } from '../../configs';
import { toastTypes } from '../../enums';
import getRoot from '../root';

const useSalesforceMarketingCloudStore = create((set, get) => ({
  configs: { enabled: false },
  loading: false,

  reset: () => set({ configs: {}, loading: false }),

  setConfigField: (name, value) => set((s) => ({ configs: { ...s.configs, [name]: value } })),

  getAuthUrl: async () => {
    try {
      const res = await axios.get(`${API_URL}/api/integrations/SalesforceMarketingCloud/auth-url`);
      if (res.data.success) {
        window.open(res.data.authUrl, '_blank');
        return res.data.authUrl;
      }
    } catch (e) {
      console.error(e);
    }
    return null;
  },

  getConfigs: async () => {
    try {
      set({ loading: true });
      const { data } = await axios.get(`${API_URL}/api/integrations/SalesforceMarketingCloud/config`);
      if (data.success) set((s) => ({ configs: { ...s.configs, ...data.config } }));
    } catch (e) { /* ignore */ } finally {
      set({ loading: false });
    }
  },

  updateConfigs: async () => {
    const root = getRoot();
    try {
      set({ loading: true });
      const { data } = await axios.post(`${API_URL}/api/integrations/SalesforceMarketingCloud/config`, { ...get().configs });
      if (data.success) {
        root.success('Successfully updated the configurations.', toastTypes.salesForceMarketingCloudUpdateConfigs);
        root.clearToast(toastTypes.salesForceMarketingCloudUpdateConfigs);
      } else throw new Error();
    } catch (e) {
      root.failure('Something went wrong...', toastTypes.salesForceMarketingCloudUpdateConfigs);
    } finally {
      get().getConfigs();
      set({ loading: false });
    }
  },

  verifyCode: async (code, tssd) => {
    const root = getRoot();
    try {
      set({ loading: true });
      const { data } = await axios.get(`${API_URL}/api/integrations/SalesforceMarketingCloud/verify-code?code=${code}&tssd=${tssd}`);
      if (data.success) {
        root.success('Verification successful.', toastTypes.salesForceMarketingCloudVerifyCode);
        root.clearToast(toastTypes.salesForceMarketingCloudVerifyCode);
      } else throw new Error();
    } catch (e) {
      root.failure('Verification unsuccessful.', toastTypes.salesForceMarketingCloudVerifyCode);
    } finally {
      set({ loading: false });
    }
  },
}));

export default useSalesforceMarketingCloudStore;
